import React from 'react'
import InstructionIndex from '../features/instructions'
function Instructions() {
  return (
    <InstructionIndex />
  )
}

export default Instructions